import { ChangeDetectionStrategy, Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslocoService } from '@jsverse/transloco';
import { AllergenEnum } from '@timechef/core/api';
import { I18nService } from '@timechef/core/i18n/i18n.service';
import { getEnumArray } from '@timechef/core/utils/array-utils';
import { AccountRepository } from '@timechef/features/account/state';
import { debounceTime } from 'rxjs';
import { Allergen } from 'src/app/features/restaurants/state/restaurants.models';
import { SwiperComponent } from 'swiper/angular';

@Component({
  selector: 'app-account-profile-modal',
  templateUrl: './account-profile-modal.component.html',
  styleUrls: ['./account-profile-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AccountProfileModalComponent implements OnInit {
  @Input() updateHasChanges?: (value: boolean) => void;
  @Input() setFocusToPhoneInput?: boolean;

  allergenItems: AllergenWithFormControl[] = [];

  i18n = inject(I18nService);

  tabs = [this.i18n.translate('ACCOUNT_PROFILE_MODAL_COMPONENT.MY_INFOS'), this.i18n.translate('ACCOUNT_PROFILE_MODAL_COMPONENT.FOOD_ALLERGIES')];
  currTab = this.tabs[0];

  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  sliderOptions = { initialSlide: 0, allowTouchMove: false };

  constructor(
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    private transloco: TranslocoService,
    private accountRepo: AccountRepository,
  ) {}

  ngOnInit(): void {
    const userAllergens: AllergenEnum[] = this.accountRepo.getAllergens();

    this.allergenItems = getEnumArray<AllergenEnum>(AllergenEnum)
      .map((allergenEnum) => {
        const isSelected = userAllergens.includes(allergenEnum);

        const ctrl = this.fb.control(isSelected);
        ctrl.valueChanges.pipe(debounceTime(300)).subscribe((isChecked) => {
          this.accountRepo.updateAllergen(allergenEnum, !!isChecked);
        });
        return {
          enum: allergenEnum,
          label: this.transloco.translate('AllergenEnum.' + allergenEnum),
          svg: '/assets/svg/dish/allergens/' + allergenEnum.toString().toLowerCase() + '.svg',
          formControl: ctrl,
        };
      })
      .sort((a, b) => (a.label! < b.label! ? -1 : 1));
  }

  changeTab(tab: string) {
    this.swiper?.swiperRef.slideTo(this.tabs.indexOf(tab));
  }

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}

interface AllergenWithFormControl extends Allergen {
  formControl: FormControl;
}
